<template>
  <!-- Quiet text button for the dismiss/cancel action, so every "Cancel" reads the same and stays
       visually quieter than the primary action next to it. Extra attrs (@click, autofocus…) fall
       through to the PrimeVue Button. -->
  <Button
    :label="label"
    variant="text"
    severity="secondary"
    v-bind="$attrs"
  />
</template>

<script setup>
// The standard cancel / dismiss button. One component, so dialogs, forms, and sheets all share the
// same low-emphasis Cancel. Pairs to the left of the primary action.
import Button from 'primevue/button';

defineOptions({ inheritAttrs: false });

defineProps({
  /** Rename it when a plain "Cancel" is ambiguous ("Keep editing", "Discard changes"). */
  label: { type: String, default: 'Cancel' },
});
</script>
